(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-trotting/assets/javascripts/status.js') >= 0) return;  svs.modules.push('/components/themes/sport-trotting/assets/javascripts/status.js'); 
var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sport_trotting = svs.themes.sport_trotting || {};

  svs.themes.sport_trotting.isFinished = function(status) {
    return !!_.contains([41], status);
  };

  svs.themes.sport_trotting.isEnded = function(status) {
    return !!_.contains([25, 41], status);
  };
  svs.themes.sport_trotting.subscribeMatch = function(params) {
    return (
      svs.themes.isDateHoursDiff(params.time, -4) &&
      !svs.themes.sport_trotting.isEnded(params.status)
    );
  };

  svs.themes.sport_trotting.hasStarted = function(status) {
    return status > 0 && !_.contains([23, 25], status);
  };

  svs.themes.sport_trotting.matchNotice = function(match) {
    var matchStatus;
    switch (match.status) {
      case 23:
        matchStatus = 'Uppskjuten';
        break;
      case 25:
        matchStatus = 'Inställd';
        break;
      case 41:
        matchStatus = 'Slut';
        break;
      default:
        matchStatus = '';
        break;
    }
    return matchStatus;
  };

  svs.themes.sport_trotting.getStatusText = function(options) {
    var text = '',
      status;

    options = _.defaults({}, options, {
      statusId: null,
      startTime: null,
      getStartTime: true
    });

    status = options.statusId;

    if (svs.themes.sport_trotting.isEnded(status)) {
      text = 'Slut';
    } else if (options.startTime && options.getStartTime) {
      text = svs.themes.formatTime(options.startTime);
    }

    return text;
  };
})(svs);

 })(window);